import React from "react";
import classnames from "classnames";
import { InputGroup } from "reactstrap";
import {
  StyledIcon,
  StyledInput1,
  StyledInput2,
  StyledInputGroup,
} from "../styles";

const isAlpha = (value) => {
  return value === "" || value.match(/^[0-9]+$/);
};

const FootprintInputText = (props) => {
  const {
    placeholder = "Write here.",
    label = "",
    defaultValue = "",
    icon,
    maxLength = 2048,
    onChange = () => {},
    show = true,
  } = props;

  return (
    <InputGroup className={classnames("input-group-merge")}>
      {!show && (
        <StyledInput1 defaultValue={defaultValue} placeholder={placeholder} />
      )}
      {show && (
        <div className="relative w-full min-w-[200px]">
          <label className="">{label}</label>
          <textarea
            rows={4}
            maxLength={maxLength}
            defaultValue={defaultValue}
            placeholder={placeholder}
            onChange={(event) => {
              const value = event.target.value;
              if (maxLength === "10") {
                if (value.length <= maxLength && isAlpha(value)) {
                  onChange(value);
                }
              } else {
                onChange(value);
              }
            }}
            className="border w-full text-lg p-2"
          />
        </div>
      )}
    </InputGroup>
  );
};

export default FootprintInputText;
